import type { AppEnvironment } from './app-environment';

export const environment: AppEnvironment = {
  name: 'de',
  production: false,
  security: {
    apiUrl: '/LND1',
    publicKey: `-----BEGIN PUBLIC KEY-----
MIICIjANBgkqhkiG9w0BAQEFAAOCAg8AMIICCgKCAgEAvRiFI/6FUCmLnfudhh2e
I8gBJCtMQBvjOEtGaCT1mgY6YVbriEZL3XkyHNxFBUPMyvwyTOiOa1zOA1rwYHvh
GMW6QE2OFFsP35GFZ8KqMq3MBBo5u8f8tXtre59xXyoOf9ojlOSDIjcUU/SscDhk
8j4kub5OjaSPtM6rj627GhF9j/Vovoywu0ZM3R5w0W5SCiDw1+4RjnEm41m3Nxbb
3n+7yjFbvihpfEubfinW5dzMB8Lm+k86e5bCDbvG82bDtMJVlaw5tYYb/S8LAue3
FBVSX9qe/qv9aAsdeJyVsEJFsCSZ4MlS9kDVPlkLTXsHusQQ81n9nUeOco+QCM2y
qLifMZUBiRaClEjjKWrU/CfsRqGsAcHBzBKEAOc+/ZCdaLW6SG/KxxzA7OPX83UZ
WsZkuv55geVgG4SMAzOq6PJmgqEGCtR9Q4XZ+JO386M4WRA1he/P75YwEiypRGru
LbxdBjODFVC+f6S5rwKHH3dM3WloEXZmS/v9jl0aQIIdfxasj5QQvrAdnU0mCd24
RjRI4ceg5gmJHK4zOm4y767LTU54ioW5XBZDxL0h6YZCrIL/vaSEeCIATH2yYCF+
oLE6UsRkXQHm1kx2f7mflRa/Z/ARJPiBqyzhT8QiGVWRKN6ssGHJvnYtO4rOBQly
AWSpC6dlVOKQ2TMYOee4BBsCAwEAAQ==
-----END PUBLIC KEY-----`,
    applicationId: 'app',
    levelId: 'NA',
  },
  api: {
    gameEndpoint: 'premiacionescreaevento',
    markEndpoint: 'premiacionesmarcaevento',
    prizeEndpoint: 'premiacionesgenerapremio',
  },
  features: { clickedEvent: false, debugWeb: false },
  prizeLinkHosts: ['de-link.copec.com'],
  interceptors: [],
  providers: [],
  routes: [],
};
